import currency from 'currency.js'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { type WebCart, type WebLineItem } from '../../common/types/webshop.types'
import { formatCurrency } from '../../common/js/currency-utility'

type Props = {
    order: WebCart
}

export default function Totals({ order }: Props) {
    if (!order) {
        return <></>
    }

    const { t } = useTranslation('common', { keyPrefix: 'purchase' });

    const discountNum = currency(order.discount * -1);
    const currencyIso = order.currencyIso;

    const subtotal = formatCurrency(order.subtotal, currencyIso);
    const tax = formatCurrency(order.tax, currencyIso);
    const discount = formatCurrency(discountNum, currencyIso);
    const total = formatCurrency(order.total, currencyIso);
    const outstanding = formatCurrency(order.outstanding, currencyIso);
    const totalPayment = formatCurrency(order.totalPayment * -1, currencyIso);

    let kitbashBundle;
    if (order != null) {
        kitbashBundle = order.lineItems.find((item: WebLineItem) => {
            return item.sku == 'SYMOPTKB';
        })
    }
    const isKitbash = kitbashBundle != null;

    return (
        <div className='checkout-totals box'>
            <div className='totals-field'>
                <label>{t('subtotal')}</label>
                <span>{subtotal}</span>
            </div>
            {order.discount > 0 && (
                <div className='totals-field'>
                    <label>{t('discount')}</label>
                    <span>{discount}</span>
                </div>
            )}
            <div className='totals-field'>
                <label>{t('taxes')}</label>
                <span>{tax}</span>
            </div>
            <hr style={{ borderColor: 'rgba(0, 0, 0, 12%)', borderStyle: 'dashed' }} />
            <div className='totals-field no-margin'>
                <label className='total-label'>{t('total')}</label>
                <span className='total-price'>{total}</span>
            </div>
            {order.totalPayment != 0 && order.totalPayment != null && (
                <>
                    <div className='totals-field no-margin'>
                        <label>{t('paid')}</label>
                        <span>{totalPayment}</span>
                    </div>
                    <div className='totals-field no-margin'>
                        <label>{t('remaining')}</label>
                        <span>{outstanding}</span>
                    </div>
                </>
            )}
            {isKitbash && (
                <p style={{fontSize: '14px', color: 'rgba(0, 0, 0, .32', marginTop: '16px'}}>
                    One purchase per customer. Not available for enterprise. This bundle is not eligible for renewal.
                </p>
            )}
            {/* This sale disclaimer comes back often enough that it's worth commenting out and uncommenting as needed
            
             <div style={{marginTop: '8px'}}>
                <hr />
                <ul>
                    <li>Limited to one purchase per customer.</li>
                    <li>Sale applies to new purchases only.</li>
                    <li>Subscriptions renew at list price.</li>
                    <li>Offer not valid for floating, dongle, or academic licensing.</li>
                    <li>For enterprise or volume pricing, please contact sales@borisfx.com</li>
                </ul>
            </div>
            */}

        </div>
    )
}
